import { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';

export default function AuthPage({ mode }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const isRegister = mode === 'register';

  if (auth.user) return <Navigate to="/sites" replace />;
  if (!auth.loading && !auth.available) {
    return (
      <div className="app narrow">
        <div className="banner warn">Accounts aren&rsquo;t available on this server (no database configured).</div>
      </div>
    );
  }

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (isRegister) await auth.register(email, password, displayName);
      else await auth.login(email, password);
      navigate('/sites');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app narrow">
      <header className="masthead">
        <div>
          <h1>{isRegister ? 'Create an account' : 'Sign in'}</h1>
          <p className="sub">
            Save exact site locations, share them with your team, and keep a record of official alerts
            at each site.
          </p>
        </div>
      </header>
      <form className="form-card" onSubmit={submit}>
        {isRegister && (
          <label>
            Name <span className="muted">(optional)</span>
            <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} maxLength={80} autoComplete="name" />
          </label>
        )}
        <label>
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        </label>
        <label>
          Password {isRegister && <span className="muted">(at least 10 characters)</span>}
          <input
            type="password"
            required
            minLength={isRegister ? 10 : undefined}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={isRegister ? 'new-password' : 'current-password'}
          />
        </label>
        {error && <div className="banner err">{error}</div>}
        <button className="btn primary" type="submit" disabled={busy}>
          {busy ? 'Please wait…' : isRegister ? 'Create account' : 'Sign in'}
        </button>
        <p className="muted form-alt">
          {isRegister ? (
            <>
              Already have an account? <Link to="/login">Sign in</Link>
            </>
          ) : (
            <>
              New here? <Link to="/register">Create an account</Link>
            </>
          )}
        </p>
        {!isRegister && (
          <p className="muted form-alt">
            Forgot your password? Reset by email isn&rsquo;t available yet — contact whoever runs this
            app.
          </p>
        )}
      </form>
    </div>
  );
}
